import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-top",
  "use": "icon-top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top\"><defs><style></style></defs><path d=\"M978.347 771.413a32 32 0 0 1-22.614-9.386l-436.48-436.054L83.2 762.453A32 32 0 1 1 37.973 716.8L496.64 258.133a32 32 0 0 1 45.227 0L1000.96 716.8a32 32 0 0 1-22.613 54.613z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol